import React, { useContext } from 'react'
import './index.scss'
import calculateTotalKnownShares from '@App/helpers/work-entities/utils/calculate-total-known-shares'
import { StoresContext } from '@App/contexts'

const PublisherRemainingShareCount = () => {
    const { workStore } = useContext(StoresContext)
    const outstandingShares = 100 - calculateTotalKnownShares(workStore.workDraftLocal)

    return (
        <div className="publisher-remaining-share-count">
            A maximum of{' '}
            <span className="blue-text bold">{Math.max(Math.trunc(outstandingShares * 100) / 100, 0)}%</span> of shares
            may be claimed
        </div>
    )
}

export default PublisherRemainingShareCount
